module.exports = __webpack_public_path__ + "static/image/main/card/image-10.ver2_0_2.png?cb892bfa";